<ul class="list-unstyled">
  <li class="pc-h-item">
    <a href="hhttps://www.scapaidiomas.com/" target="_blank" class="pc-head-link me-0 bg-gray-200">
      <img src="assets/images/ico.png" alt="logo" class="pc-head-logo" style="width: 35px;"/>
    </a>
  </li>
  <li class="dropdown pc-h-item" ngbDropdown >
    <a href="javascript:" class="pc-head-link dropdown-toggle arrow-none me-0 bg-gray-200" data-bs-toggle="dropdown" ngbDropdownToggle  (click)="toggleNoti()">
      <i antIcon type="bell" theme="outline"  ></i>
      @if(notificaciones.length > 0){
      <span class="badge bg-primary pc-h-badge">{{notificaciones.length}}</span>
      }
    </a>
    <div class="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown" ngbDropdownMenu  [ngClass]="menuVisibleNoti ? 'menuvisible' : 'novisible'">
      <div class="dropdown-header d-flex align-items-center justify-content-between">
        <h5 class="m-0">Notificaciones</h5>
        <a class="bg-transparent"><i class="text-success d-flex f-20" antIcon theme="outline" type="check-circle"></i></a>

      </div>
      <div class="dropdown-divider mb-0"></div>
      <ng-scrollbar style="min-height: 280px" visibility="hover">
        <div class="dropdown-header p-0 text-wrap header-notification-scroll">
          <div class="list-group list-group-flush w-100" *ngFor="let noti of notificaciones; index as index">
            <a class="list-group-item list-group-item-action" (click)="openDialog(noti)">
              <div class="d-flex">
                <div class="flex-shrink-0">
                  <div class="user-avatar bg-light-success"><i class="d-flex" class="material-icons" theme="outline" style="color: #060657;" >{{noti.icono}}</i></div>
                </div>
                <div class="flex-grow-1 ms-3">
      <button matMiniFab class="close-btn-msg" aria-label="Mark message as read" (click)="setasRead(noti, index, $event)">
     <span class="material-symbols-outlined">delete</span>
      </button>
                  <span class="float-start text-muted">{{ noti?.sucname || '' }}</span><span class="float-end text-muted">{{ noti?.time || '' }}</span>
                  <p class="text-body mb-0" [innerHTML]="noti.summary">

                  </p>
                   <span class="text-muted" style="display: flex;">{{noti.from ? noti.from : ''}} {{noti.assby ? noti.assby : ''}}</span>
                  <span class="text-muted">{{noti.sent}}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </ng-scrollbar>
      <div class="dropdown-divider mt-0"></div>
      <!-- <div class="text-center py-2">
        <a href="javascript:" class="link-primary">Ver Todo</a>
      </div> -->
    </div>
  </li>
  <li class="dropdown pc-h-item header-user-profile" ngbDropdown  #profileDrop="ngbDropdown">
    <a href="javascript:" class="pc-head-link dropdown-toggle arrow-none me-0" ngbDropdownToggle  (click)="toggleMenu()">
      <img [src]="userImage" alt="user-image" class="user-avatar me-2" />
      <span class="f-w-600">{{usuario}} {{apellidop | slice:0:6}}</span>
    </a>
    <div class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown" ngbDropdownMenu  [ngClass]="menuVisibleProfile ? 'menuvisible' : 'novisible'">
      <div class="dropdown-header">
        <div class="d-flex mb-1">
          <div class="flex-shrink-0">
            <img [src]="avatar" alt="user-image" class="user-avatar wid-35" />
          </div>
          <div class="flex-grow-1 ms-3 text-start">
            <h6 class="mb-0">{{usuario}} {{apellidop}}</h6>
            <span>{{rolui}}</span>
          </div>
          <a (click)="GoTo('/login')" href="javascript:" class="bg-transparent"><i class="d-flex f-20" antIcon theme="outline" type="logout" (click)="GoTo('/login')"></i></a>
        </div>
      </div>
      <ul ngbNav #nav="ngbNav" class="nav drp-tabs nav-fill nav-tabs">
        <li ngbNavItem="1">
          <a ngbNavLink>
            <i antIcon theme="outline" type="user" class="me-2"></i>
            Perfil
          </a>
          <ng-template ngbNavContent>
            @if(swap){
            <div>
                <a href="javascript:" class="dropdown-item" (click)="swapdashboard()">
             <span class="material-icons">swap_horiz</span>
                 &nbsp;&nbsp;<span>Cambiar Perfil</span>
                </a>
              </div>
            }
            @for (task of profile; track task) {
              @if(task.visible){
              <div>
                <a href="javascript:" class="dropdown-item" (click)="GoTo(task.url)">
                  <!-- <i class="text-muted" antIcon theme="outline" type="{{ task.icon }}" ></i> -->
                   <span class="material-icons">{{ task.icon }}</span>
                  <span>{{ task.title }}</span>
                </a>
              </div>
            }
            }
          </ng-template>
        </li>
        <li ngbNavItem="2">
          <a ngbNavLink>
            <i class="me-2" antIcon theme="outline" type="setting"></i>
            Ajustes
          </a>
          <ng-template ngbNavContent>
            @for (task of setting; track task) {
              <div>
                <a href="javascript:" class="dropdown-item" (click)="GoTo(task.url)">
                  <i class="text-muted" antIcon theme="outline" type="{{ task.icon }}"></i>
                  <span>{{ task.title }}</span>
                </a>
              </div>
            }
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </li>
</ul>
